import { UserBase } from '../admin/admin.types';
import { TOfferKind } from '../offer/offer.types';

export enum TalentPoolStatus {
  Default = 'draft',
  Archived = 'archived',
}

export type TalentPoolBrief = {
  id: number;
  departmentId: number | null;
  kind: TOfferKind;
  guid: string;
  position: number;
  slug: string;
  status: `${TalentPoolStatus}`;
  title: string;
};

export type TalentPoolBriefReference = TalentPoolBrief & {
  type: 'TalentPool';
};

export type TalentPool = TalentPoolBrief & {
  adminappUrl: string;
  candidatesCount: number;
  createdAt: string;
  department: string | null;
  disqualifiedCandidatesCount: number;
  example: boolean;
  followed: boolean;
  followers: UserBase[];
  mailboxEmail: string;
  qualifiedCandidatesCount: number;
  updatedAt: string;
};
